import React, { useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import MenuItem from "@material-ui/core/MenuItem";
import { compose } from "recompose";
import { enableUser } from "../../../redux/actions";

const EnableAdministratorMenuItem = ({
  onComplete,
  administrator,
  disable,
}) => {
  useEffect(() => {}, []);

  const onClick = () => {
    disable(administrator.id);
    onComplete();
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      Enable
    </MenuItem>
  );
};

const mapDispatchToProps = (dispatch) => ({
  disable: (id) => dispatch(enableUser(id)),
});

const enhance = compose(connect(undefined, mapDispatchToProps), injectIntl);

export default enhance(EnableAdministratorMenuItem);
